// Public entry point for the mini-notation engine.
//
// Callers should use `patternFromString` to parse a raw pattern string
// into a PatternSlot (mini when the grammar accepts it, raw otherwise)
// and `patternSource` to get the canonical string back out — the single
// source of truth for downstream consumers (Strudel eval, CodeMirror
// voice-color chips, visualizer).

import type { PatternSlot } from '../types';
import { parseMini } from './parser';
import { serializeMini } from './codegen';

export { parseMini } from './parser';
export { serializeMini } from './codegen';

// Convert any pattern string into a slot. Prefer structured mini; fall
// back to raw when the string is something we don't yet model so the
// block tree still round-trips losslessly.
export function patternFromString(source: string): PatternSlot {
  const result = parseMini(source);
  if (result.ok) {
    return { kind: 'mini', nodes: result.nodes };
  }
  return { kind: 'raw', source };
}

// Canonical string view of a pattern slot. For raw slots, this is the
// stored source. For mini slots, we re-serialize the node tree so
// edits to the tree show up here without the caller having to
// remember to refresh `source`.
export function patternSource(slot: PatternSlot): string {
  if (slot.kind === 'raw') return slot.source;
  return serializeMini(slot.nodes);
}
